import styled from 'styled-components';
import { FONTS, SIZE } from '@app/src/ui';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 0 auto;
  width: 280px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 427px;
  }
`;

export const WeekDay = styled.div`
  display: flex;
  width: 40px;
  height: 25px;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  line-height: 14px;
  color: #999999;
  font-family: ${FONTS.OPEN_SANS};
  margin: 0;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 0 10px;
  }
`;
